import { render, staticRenderFns } from "./HallsList.vue?vue&type=template&id=bbc33bf2&"
import script from "./HallsList.vue?vue&type=script&lang=js&"
export * from "./HallsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports